export default __webpack_public_path__ + "static/eks-prometheus-logs-d4401dd94ccc6ae71f95edddb3bd0989.png";